import { authInstance, publicInstance } from "./baseInstance";

// ===== Eligibility APIs (참여자격) =====

export const checkEligibility = async (eventType) => {
  const response = await authInstance.get(`/newyear/eligibility/check`, {
    params: { eventType },
  });
  return response.data;
};

// ===== Launchpad APIs =====

export const getLaunchpadStatus = async (eventId) => {
  const response = await authInstance.get(`/newyear/launchpad/${eventId}/status`);
  return response.data;
};

export const getQuiz = async (eventId) => {
  const response = await authInstance.get(`/newyear/launchpad/${eventId}/question`);
  return response.data;
};

export const submitAnswer = async (eventId, questionId, answer) => {
  const response = await authInstance.post(`/newyear/launchpad/${eventId}/submit`, {
    questionId,
    answer,
  });
  return response.data;
};

// ===== Lottery APIs =====

export const getLotteryStatus = async (eventId) => {
  const response = await authInstance.get(`/newyear/lottery/${eventId}/status`);
  return response.data;
};

export const subscribeLottery = async (eventId) => {
  const response = await authInstance.post(`/newyear/lottery/${eventId}/subscribe`);
  return response.data;
};

// ===== Winner Info APIs =====

export const checkWinnerEligibility = async () => {
  const response = await authInstance.get(`/newyear/winner/eligibility`);
  return response.data;
};

export const getWinnerInfo = async (eventId) => {
  const response = await authInstance.get(`/newyear/winner/${eventId}/info`);
  return response.data;
};

export const submitWinnerInfo = async (eventId, name, phone) => {
  const response = await authInstance.post(`/newyear/winner/${eventId}/info`, {
    name,
    phone,
  });
  return response.data;
};

export const updateWinnerInfo = async (eventId, name, phone, reason) => {
  const response = await authInstance.put(`/newyear/winner/${eventId}/info`, {
    name,
    phone,
    reason,
  });
  return response.data;
};
